import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export const ecomAddressViewer = {
    normalizeLoadedValue: acceptObjectValue
};

//# sourceMappingURL=definition-viewer.js.map